<template>
  <div
    class="template-container"
    :class="{
      'template-container--impersonate': isImpersonate,
      'template-container--nomargin': !hasMargin
    }"
  >
    <div class="view-container">
      <div
        class="template-main"
        :class="{ 'template-main--scroll': singleScroll }"
      >
        <slot name="main" />
      </div>
      <div :class="computedPaddingClass">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { isImpersonate } from '@/modules/common/services/partner';

@Component({})
export default class TwoColumnsContainer extends Vue {
  @Prop({ type: Boolean, default: true })
  public hasPadding?: boolean;

  @Prop({ type: Boolean, default: true })
  readonly hasMargin!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly singleScroll!: boolean;

  private isImpersonate = isImpersonate();

  public get computedPaddingClass() {
    const className = 'template-content';
    if (!this.hasPadding) {
      return `${className}--nopadding`;
    }

    return className;
  }
}
</script>

<style lang="less" scoped>
@desktop-height-navbar: 64px;
@mobile-height-navbar: 56px;
@mobile-main-container: 68vh;
@impersonate-navbar-height: 48px;
@max-width: 1300px;

.template-container {
  width: 100%;
  max-width: @max-width;
  margin: 0 auto;
  margin-top: @mobile-height-navbar;

  &.template-container--impersonate {
    margin-top: calc(@mobile-height-navbar + @impersonate-navbar-height);
  }

  &.template-container--nomargin {
    margin-top: 0;
  }

  .view-container {
    display: flex;
    flex-direction: column;
  }

  .template-main {
    width: 100%;
    min-height: @mobile-main-container;
    padding: @size-spacing-x400;
    background: @background-primary;
  }

  .template-main--scroll {
    position: initial !important;
    height: 100%;
  }

  .template-content {
    padding: @size-spacing-x400;
  }

  .template-content,
  .template-content--nopadding {
    width: 100%;
    background: @background-primary;
    padding-bottom: @spacing-xxl;
  }
}

@media @notebookUp {
  .template-container {
    margin-top: @desktop-height-navbar;

    &.template-container--impersonate {
      margin-top: calc(@desktop-height-navbar + @impersonate-navbar-height);

      .template-main {
        height: calc(
          100vh - calc(@desktop-height-navbar + @impersonate-navbar-height)
        );
        top: calc(@desktop-height-navbar + @impersonate-navbar-height);
      }
    }

    &.template-container--nomargin {
      margin-top: 0;
    }

    .view-container {
      flex-direction: row;
    }

    .template-main {
      padding: @size-spacing-x800;
      height: calc(100vh - @desktop-height-navbar);
      width: 820px;
      background: @background-secondary;
      position: sticky;
      top: @desktop-height-navbar;
    }

    .template-content {
      padding: @size-spacing-x800;
    }

    .template-content,
    .template-content--nopadding {
      max-width: 480px;
      background: @background-secondary;
      border-left: 1px solid @divider-primary;
    }
  }
}
</style>
